import { FC } from 'react';

import { BucketImg } from '@shared/components/BucketImg';

interface CouponProductCardProps {
  imageUrl: string;
  itemName: string;
  couponCode: string;
  brandName: string | null;
  selectedUnit: {
    name: string;
    image?: { url?: string };
  } | null;
}

const CouponProductCard: FC<CouponProductCardProps> = ({
  imageUrl,
  itemName,
  couponCode,
  brandName,
  selectedUnit,
}) => {
  if (selectedUnit) {
    return (
      <div className="mt-6 overflow-hidden rounded-xl border border-stone-200 bg-white">
        <div className="aspect-square w-full overflow-hidden bg-stone-100">
          {selectedUnit.image?.url ? (
            <BucketImg
              value={selectedUnit.image.url}
              size="w400"
              alt={selectedUnit.name}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-stone-400">
              No Image
            </div>
          )}
        </div>
        <div className="relative p-4 text-center">
          <div className="flex items-center justify-center">
            <span className="inline-block rounded-full bg-stone-100 px-3 py-1 text-sm font-medium text-stone-600">
              선택 상품
            </span>
            <span className="absolute right-4 text-xs text-stone-500">{couponCode}</span>
          </div>
          <h3 className="mt-2 text-lg font-medium text-stone-800">{selectedUnit.name}</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 overflow-hidden rounded-xl border border-stone-200 bg-white">
      <div className="aspect-[4/3] w-full overflow-hidden bg-stone-100">
        {imageUrl ? (
          <BucketImg
            value={imageUrl}
            size="w400"
            alt={itemName || '답례품'}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-stone-400">
            No Image
          </div>
        )}
      </div>
      <div className="p-4">
        {brandName && (
          <span className="inline-block rounded-full border border-gray-400 bg-white px-2 py-0.5 text-xs font-medium text-stone-600">
            {brandName}
          </span>
        )}
        <div className="mt-1 flex items-baseline justify-between gap-2">
          <h3 className="text-lg font-medium text-stone-800">{itemName}</h3>
          <span className="flex-shrink-0 text-xs text-stone-500">{couponCode}</span>
        </div>
      </div>
    </div>
  );
};

export default CouponProductCard;
